import React, { RefObject } from 'react';
import { TopHeadline } from '../TopHeadlineType';
import TopHeadlineItem from './TopHeadlineItem';

type TopHeadlineList = {
  topHeadlines: TopHeadline[];
  isEditView: boolean;
  listItemRef?: RefObject<HTMLLIElement | null> | undefined;
  itemToBeFocused?: number;
};

export function TopHeadlineList({ topHeadlines, isEditView, listItemRef, itemToBeFocused }: TopHeadlineList) {
  return (
    <ol className="top-headlines__list">
      {topHeadlines.map((topHeadline: TopHeadline, index: number) => (
        <TopHeadlineItem
          {...topHeadline}
          key={topHeadline.id}
          listItemRef={itemToBeFocused && index === itemToBeFocused - 1 ? listItemRef : undefined}
          index={index}
          editView={isEditView}
        />
      ))}
    </ol>
  );
}
